module.exports = __webpack_public_path__ + "img/soundsys_white.b3bf8f55.png";